module.exports = __webpack_public_path__ + "img/medal_one_black.04d73cc4.png";